import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';

@Component({
  selector: 'app-table-column-progress',
  templateUrl: './table-column-progress.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TableColumnProgressComponent extends TableViewAbstractComponent implements OnInit {
  progressSubmitState = false; // 进度分配提交按钮状态
  renderBoard: any;
  @Input('renderBoard') set ChangeRenderBoard(data: any) {
    console.log(data)
    this.renderBoard = data;
  }
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }
  ngOnInit(): void {
  }
// 进度条组件-进度赋值
  setProgressValue() {
    let count = 0;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked) {
        count = count + 1;
      }
    });
    let i = count;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked && i >= 0) {
        item.value = this.progressAverage(count)[count - i];
        i = i - 1;
      }
    });
    this.progressCalcValue();
  }
  // 平均分配
  progressAverage(count) {
    const value = [];
    let remainder = 100 % count;
    if (remainder === 0) {
      for (let i = 0; i < count; i++) {
        value.push(100 / count);
      }
    } else {
      for (let i = 0; i < count; i++) {
        if (remainder !== 0) {
          value.push(parseInt(((100 / count) + 1).toString(), 0));
          remainder = remainder - 1;
        } else {
          const num = 100 / count;
          value.push( parseInt(num.toString(), 0) );
        }
      }
    }
    return value;
  }
  // 进度条组件-复选框选中事件
  progressCheckboxChange(event) {
    const data = event;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status') {
        this.boardColumnData[i].checked = false;
      }
    }
    if (data.length > 0) {
      for (let i = 0; i < this.boardColumnData.length; i++) {
        if (this.boardColumnData[i].type === 'status') {
          for (let j = 0; j < data.length; j++) {
            if (data[j] === this.boardColumnData[i].id) {
              this.boardColumnData[i].checked = true;
              this.progressSubmitState = false;
            }
          }
        }
      }
    } else {
      for (let j = 0; j < this.boardColumnData.length; j++) {
        if (this.boardColumnData[j].type === 'status') {
          this.boardColumnData[j].checked = false;
          this.progressSubmitState = true;
        }
      }
    }
    this.setProgressValue();
  }
  // 进度条组件-提交设置
  submitProgressConfig() {
    let value = 0;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status' && this.boardColumnData[i].checked) {
        value = value + Number(this.boardColumnData[i].value);
      }
    }
    if (value > 100) {
      this.nzMessageService.create('error', '总数不能超过100%！');
      return false;
    } else {
      // 提交
      this.progressCalcValue();
    }
  }
  // 进度条组件-根据进度分配权重计算进度值
  progressCalcValue() {
    const value = [];
    const progressId = [];
    for (const key in this.boardColumnData) {
      if (this.boardColumnData.hasOwnProperty(key)) {
        if (this.boardColumnData[key].type === 'status' && this.boardColumnData[key].value && this.boardColumnData[key].checked) {
          const o = {
            key: this.boardColumnData[key].id,
            value: Number(this.boardColumnData[key].value)
          };
          value.push(o);
        }
        if (this.boardColumnData[key].type === 'progress') {
          progressId.push(this.boardColumnData[key].id);
        }
      }
    }
    for (let i = 0; i < this.renderBoard.length; i++) {
      let num = 0;
      for (const key in this.renderBoard[i].columnValues) {
        if (this.renderBoard[i].columnValues.hasOwnProperty(key)) {
          for (let j = 0; j < progressId.length; j++) {
            if (progressId[j] === key) {
              this.renderBoard[i].columnValues[key] = 0;
            }
          }
        }
      }
      for (let j = 0; j < value.length; j++) {
        if (this.renderBoard[i].columnValues[value[j].key] && this.renderBoard[i].columnValues[value[j].key].index === 2) {
          num = num + value[j].value;
          for (const key in this.renderBoard[i].columnValues) {
            if (this.renderBoard[i].columnValues.hasOwnProperty(key)) {
              for (let k = 0; k < progressId.length; k++) {
                if (progressId[k] === key) {
                  this.renderBoard[i].columnValues[key] = num;
                }
              }
            }
          }
        }
      }
    }
  }
}
